import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { apiQuery } from "../../utils/AppConfig";
import { Response } from "../../types/response/Response";
import { CategoryDTO } from "../../types/category/CategoryDTO";
import { ResponsePageable } from "../../types/response/ResponsePageable";
import { CategoryCreateDTO } from "../../types/category/CategoryCreateDTO";
import { CityDTO } from "../../types/city/CityDTO";

export const categoryApi = createApi({
  reducerPath: "categoryUrl",
  baseQuery: apiQuery,
  tagTypes: ["categoryUrl"],
  endpoints: (builder) => ({
    getCategories: builder.query<
      Response<ResponsePageable<CategoryDTO[]>>,
      {
        page: number;
        size: number;
      }
    >({
      query: (dto) => ({
        url: `/categories?page=${dto.page}&size=${dto.size}`,
        method: "GET",
      }),
      providesTags: ["categoryUrl"],
    }),
    createCategory: builder.mutation<void, Partial<CategoryCreateDTO>>({
      query: (dto) => ({
        url: "/categories",
        method: "POST",
        body: dto,
      }),
      invalidatesTags: ["categoryUrl"],
    }),
    updateCategory: builder.mutation<
      void,
      Partial<{ id: number; dto: CategoryCreateDTO }>
    >({
      query: ({ id, dto }) => ({
        url: `/categories/${id}`,
        method: "PATCH",
        body: dto,
      }),
      invalidatesTags: ["categoryUrl"],
    }),
    getCities: builder.query<
      Response<CityDTO[]>,
      { page: number; size: number }
    >({
      query: (dto) => ({
        url: `/cities?page=${dto.page}&size=${dto.size}`,
        method: "GET",
      }),
      providesTags: ["categoryUrl"],
    }),
    getEmployee: builder.query<
      Response<CategoryDTO[]>,
      {
        page: number;
        size: number;
      }
    >({
      query: (dto) => ({
        url: `/employees?page=${dto.page}&size=${dto.size}`,
        method: "GET",
      }),
      providesTags: ["categoryUrl"],
    }),
  }),
});

export const {
  useGetCategoriesQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useGetCitiesQuery,
  useGetEmployeeQuery,
} = categoryApi;
